import React, { useState } from "react";
import env from "../../../../config";

const OAUTH_URL = `https://app.gohighlevel.com/integration/${env.CUSTOMIZR_MODULE_GHL.APP_ID}?app_from=marketplace&view=agency`;

const ModuleConnect = ({
  icon = "bi bi-link-45deg",
  title = "Connect Your Account",
  description = "To unlock this module, connect your GoHighLevel account so we can save credentials for your sub-account workflows.",
}) => {
  const [open, setOpen] = useState(false);

  const handleConnect = () => {
    window.open(OAUTH_URL, "_blank", "noopener,noreferrer");
    setOpen(true);
  };

  const handleClose = () => setOpen(false);
  const handleRefresh = () => window.location.reload();

  return (
    <div className="module-connect-page">
      <style>{`
        .module-connect-page {
          min-height: 100vh;
          background: linear-gradient(160deg, #f8fafc 0%, #eef2ff 50%, #f8fafc 100%);
          padding: 48px 16px;
        }
        .module-connect-page .hero-card {
          border-radius: 20px;
          background: #ffffff;
          box-shadow: 0 8px 30px rgba(15, 23, 42, 0.06), 0 2px 8px rgba(15, 23, 42, 0.03);
          overflow: hidden;
        }
        .module-connect-page .hero-banner {
          background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 60%, #ec4899 100%);
          padding: 28px 28px 36px;
          color: #ffffff;
          position: relative;
          overflow: hidden;
        }
        .module-connect-page .hero-banner h1.hero-title {
          font-size: 1.5rem !important;
          line-height: 1.25 !important;
          font-weight: 700 !important;
          margin: 0 0 8px !important;
          letter-spacing: -0.01em;
        }
        .module-connect-page .hero-banner p.hero-desc {
          font-size: 0.9rem !important;
          line-height: 1.55 !important;
          margin: 0 !important;
          color: rgba(255, 255, 255, 0.88);
          max-width: 720px;
        }
        @media (min-width: 768px) {
          .module-connect-page .hero-banner h1.hero-title {
            font-size: 1.75rem !important;
          }
          .module-connect-page .hero-banner p.hero-desc {
            font-size: 0.95rem !important;
          }
        }
        .module-connect-page .hero-banner::before {
          content: "";
          position: absolute;
          top: -120px;
          right: -120px;
          width: 320px;
          height: 320px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(255,255,255,0.18), transparent 70%);
          pointer-events: none;
        }
        .module-connect-page .hero-banner::after {
          content: "";
          position: absolute;
          bottom: -140px;
          left: -100px;
          width: 280px;
          height: 280px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(255,255,255,0.12), transparent 70%);
          pointer-events: none;
        }
        .module-connect-page .hero-icon {
          width: 56px;
          height: 56px;
          border-radius: 14px;
          background: rgba(255, 255, 255, 0.18);
          backdrop-filter: blur(8px);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 14px;
          border: 1px solid rgba(255, 255, 255, 0.25);
        }
        .module-connect-page .hero-icon i {
          font-size: 1.6rem;
        }
        .module-connect-page .hero-pill {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(255, 255, 255, 0.18);
          color: #ffffff;
          font-weight: 600;
          font-size: 12px;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          padding: 6px 12px;
          border-radius: 999px;
          border: 1px solid rgba(255, 255, 255, 0.22);
        }
        .module-connect-page .step-card {
          border-radius: 16px;
          padding: 22px;
          background: #ffffff;
          border: 1px solid #eef0f4;
          height: 100%;
          transition: border-color 0.2s ease, box-shadow 0.2s ease;
        }
        .module-connect-page .step-card.critical {
          border-color: #fde68a;
          background: linear-gradient(180deg, #fffbeb 0%, #ffffff 100%);
          box-shadow: 0 0 0 1px rgba(245, 158, 11, 0.15);
        }
        .module-connect-page .step-card .step-number {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: linear-gradient(135deg, #6366f1, #8b5cf6);
          color: #ffffff;
          font-weight: 700;
          font-size: 15px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 6px 16px rgba(99, 102, 241, 0.3);
          margin-bottom: 14px;
        }
        .module-connect-page .step-card h6 {
          font-size: 1rem;
          line-height: 1.35;
          word-break: break-word;
        }
        .module-connect-page .step-card .accent {
          font-weight: 700;
          white-space: nowrap;
        }
        .module-connect-page .step-card.critical .step-number {
          background: linear-gradient(135deg, #f59e0b, #ef4444);
          box-shadow: 0 6px 16px rgba(239, 68, 68, 0.3);
        }
        .module-connect-page .toggle-mock {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 8px 14px;
          border-radius: 999px;
          background: #ecfdf5;
          border: 1px solid #a7f3d0;
          color: #047857;
          font-weight: 600;
          font-size: 13px;
          margin-top: 10px;
        }
        .module-connect-page .toggle-mock .switch {
          width: 32px;
          height: 18px;
          border-radius: 999px;
          background: #10b981;
          position: relative;
          flex-shrink: 0;
        }
        .module-connect-page .toggle-mock .switch::after {
          content: "";
          position: absolute;
          top: 2px;
          right: 2px;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          background: #ffffff;
          box-shadow: 0 1px 2px rgba(0,0,0,0.2);
        }
        .module-connect-page .checkbox-mock {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 6px 12px;
          border-radius: 8px;
          background: #eef2ff;
          border: 1px solid #c7d2fe;
          color: #3730a3;
          font-weight: 600;
          font-size: 13px;
          margin-top: 10px;
        }
        .module-connect-page .checkbox-mock .box {
          width: 16px;
          height: 16px;
          border-radius: 4px;
          background: #4f46e5;
          color: #ffffff;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
        }
        .module-connect-page .cta-btn {
          background: linear-gradient(135deg, #6366f1, #8b5cf6);
          border: none;
          color: #ffffff;
          padding: 14px 36px;
          border-radius: 12px;
          font-weight: 600;
          font-size: 15px;
          display: inline-flex;
          align-items: center;
          gap: 10px;
          box-shadow: 0 10px 24px rgba(99, 102, 241, 0.35);
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }
        .module-connect-page .cta-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 14px 28px rgba(99, 102, 241, 0.4);
          color: #ffffff;
        }
        .module-connect-page .section-label {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.8px;
          text-transform: uppercase;
          color: #6366f1;
          margin-bottom: 8px;
        }
      `}</style>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-11">
            <div className="hero-card">
              <div className="hero-banner">
                <div className="hero-pill">
                  <i className="bi bi-shield-lock"></i>
                  Connection Required
                </div>
                <div className="hero-icon mt-3">
                  <i className={icon}></i>
                </div>
                <h1 className="hero-title">{title}</h1>
                <p className="hero-desc">{description}</p>
              </div>

              <div className="p-4 p-md-5">
                <div
                  className="d-flex align-items-center gap-3 p-3 rounded-3 mb-4"
                  style={{
                    background: "#eef2ff",
                    border: "1px solid #c7d2fe",
                    color: "#3730a3",
                  }}
                >
                  <i
                    className="bi bi-unlock-fill"
                    style={{ fontSize: 20, flexShrink: 0 }}
                  ></i>
                  <div className="small">
                    <strong>Connect your account</strong> to unlock this
                    feature. The setup takes less than a minute.
                  </div>
                </div>

                <div className="section-label">
                  <i className="bi bi-list-check"></i>
                  How to connect &mdash; follow these steps exactly
                </div>
                <div className="row g-3 mb-4">
                  <div className="col-12 col-md-6 col-xl-4">
                    <div className="step-card">
                      <div className="step-number">1</div>
                      <h6 className="fw-bold mb-2">Choose Agency</h6>
                      <p className="text-muted small mb-0">
                        On the GoHighLevel screen, select your{" "}
                        <strong>Agency</strong> account &mdash; not an
                        individual sub-account &mdash; so this module can
                        operate across all of your locations.
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-xl-4">
                    <div className="step-card critical">
                      <div className="step-number">2</div>
                      <h6 className="fw-bold mb-2">
                        Select <span className="accent text-danger">ALL</span>{" "}
                        Locations
                      </h6>
                      <p className="text-muted small mb-2">
                        On the location list, tick the master checkbox at the
                        top so every existing sub-account is included.
                      </p>
                      <span className="checkbox-mock">
                        <span className="box">
                          <i className="bi bi-check-lg"></i>
                        </span>
                        Select all locations
                      </span>
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-xl-4">
                    <div className="step-card critical">
                      <div className="step-number">3</div>
                      <h6 className="fw-bold mb-2">
                        Enable{" "}
                        <span className="accent text-warning">
                          Future Locations
                        </span>
                      </h6>
                      <p className="text-muted small mb-2">
                        Turn on the <strong>&ldquo;Enable for Future
                        Locations&rdquo;</strong> toggle so any sub-account you
                        add later is auto-connected. Without it, new locations
                        won&rsquo;t work with this module.
                      </p>
                      <span className="toggle-mock">
                        <span className="switch"></span>
                        Future locations: ON
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  className="d-flex align-items-start gap-3 p-3 rounded-3 mb-4"
                  style={{
                    background: "#fef3c7",
                    border: "1px solid #fcd34d",
                    color: "#78350f",
                  }}
                >
                  <i
                    className="bi bi-exclamation-triangle-fill mt-1"
                    style={{ fontSize: 18 }}
                  ></i>
                  <div className="small">
                    <strong>Critical:</strong> If you skip step 2 or 3,
                    sub-accounts you add later <em>will not</em> be authorized
                    and this module will silently fail for those locations.
                    Double-check both before clicking <em>Authorize</em> on
                    GoHighLevel.
                  </div>
                </div>

                <div className="text-center pt-2">
                  <button className="cta-btn" onClick={handleConnect}>
                    <i className="bi bi-box-arrow-up-right"></i>
                    Connect with GoHighLevel
                  </button>
                  <div className="text-muted small mt-3">
                    Opens GoHighLevel in a new tab. Return here once
                    authorization completes.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {open && (
        <div
          className="modal fade show d-block"
          tabIndex={-1}
          style={{ backgroundColor: "rgba(15, 23, 42, 0.6)", zIndex: 2000 }}
          onClick={(e) => {
            if (e.target === e.currentTarget) handleClose();
          }}
        >
          <style>{`
            .module-connect-guide .modal-content {
              border-radius: 18px;
              overflow: hidden;
              border: none;
            }
            .module-connect-guide .modal-banner {
              background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
              padding: 28px 24px 60px;
              color: #ffffff;
              text-align: center;
              position: relative;
              overflow: hidden;
            }
            .module-connect-guide .modal-banner::after {
              content: "";
              position: absolute;
              bottom: -40px;
              left: 0;
              right: 0;
              height: 80px;
              background: #ffffff;
              border-radius: 50% 50% 0 0 / 100% 100% 0 0;
            }
            .module-connect-guide .pulse-icon {
              width: 76px;
              height: 76px;
              border-radius: 50%;
              background: rgba(255,255,255,0.18);
              border: 1px solid rgba(255,255,255,0.3);
              display: inline-flex;
              align-items: center;
              justify-content: center;
              color: #ffffff;
              animation: pulse-soft 2.2s ease-in-out infinite;
              margin-bottom: 14px;
            }
            .module-connect-guide .step-pill {
              width: 28px;
              height: 28px;
              border-radius: 50%;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              font-weight: 700;
              font-size: 13px;
              flex-shrink: 0;
              background: linear-gradient(135deg, #6366f1, #8b5cf6);
              color: #ffffff;
            }
            .module-connect-guide .step-pill.critical {
              background: linear-gradient(135deg, #f59e0b, #ef4444);
            }
            .module-connect-guide .step-row {
              display: flex;
              gap: 12px;
              align-items: flex-start;
              padding: 10px 0;
            }
            @keyframes pulse-soft {
              0%, 100% { box-shadow: 0 0 0 0 rgba(255,255,255,0.4); }
              50%      { box-shadow: 0 0 0 14px rgba(255,255,255,0); }
            }
          `}</style>
          <div className="modal-dialog modal-dialog-centered module-connect-guide">
            <div className="modal-content shadow-lg">
              <div className="modal-banner">
                <div className="pulse-icon">
                  <i
                    className="bi bi-arrow-repeat"
                    style={{ fontSize: 30 }}
                  ></i>
                </div>
                <h5 className="fw-bold mb-1">
                  Authorization opened in a new tab
                </h5>
                <p
                  className="mb-0 small"
                  style={{ color: "rgba(255,255,255,0.85)" }}
                >
                  Complete the steps below in GoHighLevel.
                </p>
                <button
                  type="button"
                  className="btn-close btn-close-white position-absolute"
                  style={{ top: 14, right: 14 }}
                  onClick={handleClose}
                ></button>
              </div>

              <div
                className="modal-body pt-0 px-4"
                style={{ marginTop: -28, position: "relative" }}
              >
                <div className="text-start">
                  <div className="step-row">
                    <span className="step-pill">1</span>
                    <div className="small">
                      Switch to the new tab and pick your{" "}
                      <strong>Agency</strong> account.
                    </div>
                  </div>
                  <div className="step-row">
                    <span className="step-pill critical">2</span>
                    <div className="small">
                      Tick <strong>Select all locations</strong> so every
                      sub-account is included.
                    </div>
                  </div>
                  <div className="step-row">
                    <span className="step-pill critical">3</span>
                    <div className="small">
                      Turn on{" "}
                      <strong>&ldquo;Enable for Future Locations&rdquo;</strong>{" "}
                      so new sub-accounts get connected automatically.
                    </div>
                  </div>
                  <div className="step-row">
                    <span className="step-pill">4</span>
                    <div className="small">
                      Click <strong>Authorize</strong>, then return here and{" "}
                      <strong>refresh</strong> the page.
                    </div>
                  </div>
                </div>

                <div
                  className="mt-3 p-3 rounded-3 d-flex align-items-start gap-2"
                  style={{
                    background: "#fef3c7",
                    border: "1px solid #fcd34d",
                    color: "#78350f",
                    fontSize: "0.8rem",
                  }}
                >
                  <i className="bi bi-info-circle-fill mt-1"></i>
                  <span>
                    Don&rsquo;t close this window. Once GoHighLevel confirms,
                    click <strong>Refresh Page</strong> below.
                  </span>
                </div>
              </div>

              <div className="modal-footer border-0 pt-2 d-flex justify-content-between">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={handleClose}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn px-4 d-inline-flex align-items-center gap-2"
                  onClick={handleRefresh}
                  style={{
                    background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
                    color: "#ffffff",
                    border: "none",
                  }}
                >
                  <i className="bi bi-arrow-clockwise"></i>
                  Refresh Page
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModuleConnect;
